<template>
  <div>
    <b-dropdown class="dropdown-files" :disabled="disabled">
      <template #button-content>
        <i class="icofont-download"></i>
        Exportar
      </template>

      <slot name="items"></slot>

      <b-dropdown-item v-if="pdfEnabled" href="#" @click="generatePdf()"
        ><i class="icofont-file-pdf"></i> {{ pdfLabel }}
      </b-dropdown-item>
      <b-dropdown-item v-if="xlsEnabled" href="#" @click="postLog()"
        ><download-excel
          :data="data"
          :fields="fields"
          worksheet="My Worksheet"
          :name="`${name}.xls`"
          class="dropdown-files-xls"
        >
          <i class="icofont-file-excel"></i> {{ xlsLabel }}
        </download-excel></b-dropdown-item
      >
      <!-- <b-dropdown-item href="#"
        ><download-excel
          :data="data"
          :fields="fields"
          worksheet="My Worksheet"
          name="filename.xls"
          type="csv"
          class="dropdown-files-xls"
          :escapeCsv="false"
        >
          <i class="icofont-file-excel"></i> CSV
        </download-excel></b-dropdown-item
      > -->
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'DownloadFiles',
  props: {
    data: {
      type: [Array, Boolean],
      default: [],
    },
    fields: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: 'file',
    },
    callbackPdf: {
      type: [Function, Boolean],
      default: false,
    },
    pdfEnabled: {
      type: Boolean,
      default: true,
    },
    xlsEnabled: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pdfLabel: {
      type: String,
      default: 'PDF',
    },
    xlsLabel: {
      type: String,
      default: 'XLS',
    },
  },
  data() {
    return {}
  },
  methods: {
    generatePdf() {
      this.postLog()
      this.callbackPdf()
    },
    postLog() {
      const payload = {
        id: this.$store.state.id,
        nome: this.$store.state.username,
        cod_ibge: this.$store.state.cod_ibge,
        page: this.$route.path,
      }
      this.$api.post('/app/logs-download', payload)
    },
  },
}
</script>

<style>
.dropdown-files button.dropdown-toggle {
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
}
.dropdown-files ul {
  padding: 10px !important;
  border-radius: initial !important;
  align-items: center;
  justify-content: flex-start;
}
.dropdown-files ul li a {
  padding: 5px 15px;
}
.dropdown-files .btn-exportar {
  padding: 5px 15px;
}
</style>
